module.exports = __webpack_public_path__ + "static/media/About_Marketing.8550ffdd.svg";